import { Component, Input, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
export const textAreaConstants: any = {
    textAreaForStoryName: 'storyName',
};
/* eslint-disable @typescript-eslint/naming-convention */
const EditableValueProvider = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AutosizeTextAreaComponent),
    multi: true
};

@Component({
    selector: 'agpr-autosize-text-area',
    templateUrl: './autosize-text-area.component.html',
    styleUrls: ['./autosize-text-area.component.scss'],
    providers: [EditableValueProvider],
    standalone: false
})
export class AutosizeTextAreaComponent implements ControlValueAccessor {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() textAreaMaxLength: number;
    @Input() textAreaCols: number;
    @Input() placeholder: string;
    @Input() placeholderIcon: string;
    @Input() boxStyle: string;
    @Input() isDisabled: boolean = false;
    @Input() isMultiLine: boolean = true;
    @Input() textAreaType: string = '';
    @Input() errorsId: string;
    @Input() ariaLabel: string;

    public editable: boolean = false;
    public content: string = '';
    public isHidden = false;
    public contentOriginalValue = '';

    constructor(public element: ElementRef) { }

    registerOnTouched(fn: () => void): void { }
    propagateChange: any = () => { };

    writeValue(value: any): void {
        this.content = value;
        this.contentOriginalValue = value;
    }


    registerOnChange(fn): void {
        this.propagateChange = fn;
    }

    public onTextChange(event): void {
        this.propagateChange(event.target.value);
    }

    public onFocusTextInput(): void {
        this.editable = true;
    }

    public onFocusOutTextInput(): void {
        this.content = this.content.trim();
        this.editable = false;
    }

    public onEdit(): void {
        if (this.isDisabled) {
            return;
        }
        this.editable = true;
    }

    public getContents(content: string): string[] {
        let splitedContents: string[] = [];
        if (content) {
            splitedContents = content.split(/\n/g);
        }
        return splitedContents;
    }
}
